// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.QHc_RlXwTXyeeiPPCqr9 {
    display: flex;
    flex-direction: row;
    margin-bottom: 20;
}

.X1HMTJLyySBHkwe4UrwQ {
    display: flex;
    flex-direction: row;
}

.H0dcPTGPDfg3FVHVbdNh {
    line-height: 36px;
    font-size: 10px;
}
`, "",{"version":3,"sources":["webpack://./src/pages/dashboard/interests/interests-toolbar/interest-toolbar.module.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,mBAAmB;IACnB,iBAAiB;AACrB;;AAEA;IACI,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,iBAAiB;IACjB,eAAe;AACnB","sourcesContent":[".container {\n    display: flex;\n    flex-direction: row;\n    margin-bottom: 20;\n}\n\n.wrapper {\n    display: flex;\n    flex-direction: row;\n}\n\n.sortCriteria {\n    line-height: 36px;\n    font-size: 10px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `QHc_RlXwTXyeeiPPCqr9`,
	"wrapper": `X1HMTJLyySBHkwe4UrwQ`,
	"sortCriteria": `H0dcPTGPDfg3FVHVbdNh`
};
export default ___CSS_LOADER_EXPORT___;
